import { apiClient, web3Client } from "../../../api/clients";
const environment = process.env.REACT_APP_WALLET_TYPE;

const getTransactionGridDetils=(id,type,wallet,search,fromDate,Todate,pageNo,pageSize)=>{
	if(environment === 'non_custodial'){
        return web3Client.get(`Merchant/transactions/${id}/${type}/${wallet}/${search}/${fromDate}/${Todate}?page=${pageNo}&pageSize=${pageSize}`);
    }else{
		return apiClient.get(`Merchant/transactions/${id}/${type}/${wallet}/${search}/${fromDate}/${Todate}?page=${pageNo}&pageSize=${pageSize}`);
    }
}
const downloadTransaction=(id,type)=>{
	if(environment === 'non_custodial'){
        return web3Client.get(`TemplatesTranction/${id}/${type}`); 
    }else{
		return apiClient.get(`TemplatesTranction/${id}/${type}`);  
    }
}
const getTransactions=()=>{
	if(environment === 'non_custodial'){
        return web3Client.get(`Merchant/TransactionType`);
    }else{
        return apiClient.get(`Merchant/TransactionType`);
    }
}
const getWallets=(customerId)=>{
	if(environment === 'non_custodial'){
        return web3Client.get(`Merchant/TransactionWalletsLU/${customerId}`);
    }else{
		return apiClient.get(`Merchant/TransactionWalletsLU/${customerId}`);
    }
}
const viewTransactionDetailes=(transactionId)=>{
	if(environment === 'non_custodial'){
        return web3Client.get(`ExchangeTransaction/transaction/${transactionId}`)
    }else{
		return apiClient.get(`ExchangeTransaction/transaction/${transactionId}`)
    }
}
export {
    getTransactions,getTransactionGridDetils,downloadTransaction,getWallets,viewTransactionDetailes
 }